import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <div className='footer-container'>
        <Link to='/'>
            <img src={'/images/img-logo.PNG'} alt="vson.ary" className='footer-logo' />
        </Link>
        <div className='footer-links'>
            <div className='footer-link-wrapper'>
                <div className='footer-link-items'>
                    <h2><Link to='/portfolio'>Portfolio</Link></h2>
                    <Link to='/portfolio/cars'>Cars</Link>
                    <Link to='/portfolio/motorsports'>Motorsports</Link>
                    <Link to='/portfolio/sports'>Sports</Link>
                    <Link to='/portfolio/portraits'>Portraits</Link>
                    <Link to='/portfolio/events'>Events</Link>
                    <Link to='/portfolio/travel'>Travel</Link>
                </div>
                {/* <div className='footer-link-items'>
                    <h2><Link to='/services'>Services</Link></h2>
                    <Link to='/services/cars'>Cars</Link>
                    <Link to='/services/motorsports'>Motorsports</Link>
                    <Link to='/services/events'>Events</Link>
                    <Link to='/services/sports'>Sports</Link>
                    <Link to='/services/portraits'>Portraits</Link>
                </div> */}
                <div className='footer-link-items'>
                    <h2><Link to='/inquire'>Connect with Me</Link></h2>
                    <Link to='https://instagram.com/vson.ary' external={true} target="_blank">
                        Instagram
                        <FontAwesomeIcon icon={faInstagram} style={{ marginLeft: '8px' }} />
                        </Link>
                    <Link to='/about-me'>About Me</Link>
                    <Link to='/inquire'>Inquire</Link>
                </div>
            </div>
        </div>
        <small className='copyright'>© 2023-2026 Vanson Nguyen | vson.ary </small>
    </div>
  )
}

export default Footer
